import React, {useState} from 'react'
import {PaymentAccount, PaymentType} from '../../types/app-types'
import {formatPaymentAccountFull} from '../../services/utils'

interface PaymentMethodOption {
  id: string
  label: string
  disabled: boolean
  paymentType?: PaymentType
  paymentAccount?: PaymentAccount
}

interface PaymentMethodSelectProps {
  className?: string
  disabled?: boolean
  paymentAccounts: PaymentAccount[]
  onPaymentMethodSelect: (
    paymentType: PaymentType,
    paymentAccount: PaymentAccount
  ) => void
}

const choosePaymentMethodOption = {
  id: 'choose-payment-method',
  label: 'Choose a payment method',
  disabled: true
}

const oneTimePaymentOptionCC = {
  id: 'payment-one-time-cc',
  label: 'One Time Payment - Credit Card',
  paymentType: PaymentType.OneTimePaymentCC,
  disabled: false
}

const oneTimePaymentOption = {
  id: 'payment-one-time',
  label: 'One Time Payment - ACH Direct Debit',
  paymentType: PaymentType.OneTimePaymentACH,
  selected: false,
  disabled: false
}

function getPaymentTypeForAccount(adyenPaymentMethod: string): PaymentType {
  switch (adyenPaymentMethod) {
    case 'Credit Card':
      return PaymentType.AccountCC
    case 'Direct Debit':
      return PaymentType.AccountACH
    default:
      return null
  }
}

function createPaymentMethodOptions(
  paymentAccounts: PaymentAccount[]
): PaymentMethodOption[] {
  const paymentAccountOptions = paymentAccounts
    ? paymentAccounts.map(paymentAccount => {
        return {
          id: paymentAccount.id,
          label: formatPaymentAccountFull(paymentAccount),
          paymentType: getPaymentTypeForAccount(
            paymentAccount.adyenPaymentMethod
          ),
          disabled: false,
          paymentAccount
        }
      })
    : []
  return [
    choosePaymentMethodOption,
    oneTimePaymentOption,
    oneTimePaymentOptionCC,
    ...paymentAccountOptions
  ]
}

const PaymentMethodSelect = ({
  className,
  disabled,
  paymentAccounts,
  onPaymentMethodSelect
}: PaymentMethodSelectProps) => {
  const paymentMethodOptions = createPaymentMethodOptions(paymentAccounts)
  const [paymentMethod, selectPaymentMethod] = useState(paymentMethodOptions[0])

  return (
    <div className={className}>
      <div className="form-control py-2">
        <label className="label label-text">Payment Method</label>
        <select
          className="select select-bordered select-primary"
          disabled={disabled}
          defaultValue={paymentMethodOptions[0].id}
          onChange={e => {
            const selection = paymentMethodOptions[e.target.selectedIndex]
            selectPaymentMethod(selection)
            onPaymentMethodSelect(
              selection.paymentType,
              selection.paymentAccount
            )
          }}
        >
          {paymentMethodOptions.map(({id, label, disabled}) => (
            <option key={id} value={id} disabled={disabled}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default PaymentMethodSelect
